<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <center v-if="load">
        <b-spinner
          variant="primary"
          label="جاري التحميل..."
        />
      </center>

      <b-row v-else>
        <b-col
          v-if="task.success == false"
          cols="12"
        >
          <center>
            {{ task.message }}
          </center>
        </b-col>
        <b-col
          v-else
          cols="12"
        >
          <b-card class="mb-2 task-details-card">
            <h3 class="mb-2 task-title">
              {{ task.name }}
            </h3>
            <div class="mb-2 task-badges-section">
              <div class="badges-row">
                <b-badge
                  :variant="badgeVariant(task.status)"
                  class="task-badge"
                >
                  {{ task.status_label || capitalize(task.status) }}
                </b-badge>
                <b-badge
                  :variant="priorityVariant(task.priority)"
                  class="task-badge ml-1"
                >
                  {{ task.priority_label || capitalize(task.priority) }}
                </b-badge>
                <span
                  v-if="task.is_overdue"
                  class="text-danger ml-1 overdue-text"
                >(Overdue)</span>
              </div>
              <b-link
                :to="{ name: 'project_details', params: { id: task.project_id } }"
                class="btn btn-sm btn-primary ml-1 project-link-btn"
              >
                عرض المشروع
              </b-link>
            </div>
            <ul class="list-unstyled mb-2 task-info-list">
              <li
                v-if="task.estimated_hours"
                class="task-info-item"
              >
                <strong>Estimated Hours:</strong> {{ task.estimated_hours }}
              </li>
              <li
                v-if="task.actual_hours"
                class="task-info-item"
              >
                <strong>Actual Hours:</strong> {{ task.actual_hours }}
              </li>
              <li
                v-if="task.due_date"
                class="task-info-item"
              >
                <strong>Due Date:</strong> {{ formatDate(task.due_date) }}
              </li>
              <li
                v-if="task.completed_at"
                class="task-info-item"
              >
                <strong>Completed At:</strong> {{ formatDate(task.completed_at) }}
              </li>
            </ul>
            <div
              v-if="task.assigned_employee"
              class="mb-2 employee-section"
            >
              <strong class="section-label">الموظف المكلف:</strong>
              <b-card
                class="p-2 my-1 employee-card"
                body-class="p-1"
              >
                <div class="d-flex align-items-center employee-info">
                  <div class="employee-avatar-wrapper">
                    <b-avatar
                      v-if="task.assigned_employee.avatar_link"
                      :src="task.assigned_employee.avatar_link"
                      size="40"
                      class="employee-avatar"
                    />
                    <b-avatar
                      v-else
                      variant="primary"
                      size="40"
                      class="employee-avatar"
                    >
                      {{ task.assigned_employee.full_name ? task.assigned_employee.full_name[0] : '' }}
                    </b-avatar>
                  </div>
                  <div class="mr-1 ml-1 employee-details">
                    <div class="employee-name">
                      <strong>{{ task.assigned_employee.full_name }}</strong> <span
                        v-if="task.assigned_employee.nack_name"
                        class="employee-nickname"
                      >({{ task.assigned_employee.nack_name }})</span>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <div
              v-if="task.description"
              class="mb-2 description-section"
            >
              <strong class="section-label">Description:</strong>
              <b-card-text class="description-text">
                {{ task.description }}
              </b-card-text>
            </div>
            <div
              v-if="task.notes"
              class="mb-2 notes-section"
            >
              <strong class="section-label">Notes:</strong>
              <b-card-text class="notes-text">
                {{ task.notes }}
              </b-card-text>
            </div>
          </b-card>

          <!-- Comments Section -->
          <task-comments
            v-if="taskId"
            :task-id="taskId"
          />

          <!-- Activity Logs Section -->
          <b-row
            v-if="hasPermission('view activity_logs')"
            class="mt-3"
          >
            <b-col cols="12">
              <b-card header="سجل النشاطات">
                <ActivityLogs
                  :model-type="'ProjectTask'"
                  :model-id="Number(taskId)"
                  :show-filters="true"
                  :per-page="15"
                />
              </b-card>
            </b-col>
          </b-row>
        </b-col>

      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BButton, BFormCheckbox, BCard, BRow, BCol, BBadge, BCardText,
  BAvatar, BLink, VBTooltip, BSpinner, BPagination, BFormInput, BInputGroup,
  BForm, BFormGroup, BFormDatepicker, BFormRadio, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import flatPickr from 'vue-flatpickr-component'
import ActivityLogs from '@/components/ActivityLogs.vue'
import TaskComments from './components/TaskComments.vue'

export default {
  components: {
    BTable,
    flatPickr,
    BFormTextarea,
    BFormRadio,
    BFormDatepicker,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    TaskComments,
    ActivityLogs,
  },
  watch: {
    '$route.params.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.init() // or whatever method loads the task data
      }
    },
  },
  computed: {
    ...mapGetters({
      task: 'tasks/task',
      load: 'tasks/load',
    }),
    taskId() {
      return this.$route.params.id ? this.$route.params.id : null
    },

  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {

    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('tasks/showTask', { taskId: this.taskId })
    },
    capitalize(str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    formatDate(date) {
    // Customizable formatting or use a date library if you prefer
      return new Date(date).toLocaleDateString()
    },
    badgeVariant(status) {
      switch (status) {
        case 'pending': return 'warning'
        case 'completed': return 'success'
        case 'in_progress': return 'primary'
        default: return 'secondary'
      }
    },
    priorityVariant(priority) {
      switch (priority) {
        case 'high': return 'danger'
        case 'medium': return 'warning'
        case 'low': return 'info'
        default: return 'secondary'
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.customer-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-right: 4px solid #7367f0;
}

.customer-avatar {
    font-weight: bold;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.info-item {
    display: flex;
    align-items: flex-start;

    div {
        flex: 1;
    }
}

.financial-info {
    .financial-item {
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            transform: translateY(-2px);
        }
    }
}

.additional-info {
    .info-row {
        &:last-child {
            border-bottom: none !important;
        }
    }
}

.card {
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    border: 1px solid #e9ecef;

    .card-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        font-weight: 600;
        color: #495057;
        text-align: right;
    }
}

// RTL Support
.text-right {
    text-align: right;
}

.ml-1 {
    margin-right: 0.25rem;
    margin-left: 0 !important;
}

.ml-2 {
    margin-right: 0.5rem;
    margin-left: 0 !important;
}

/* Task Details Mobile Responsive Styles */
.task-details-card {
    padding: 1rem;
}

.task-title {
    font-size: 1.5rem;
    font-weight: 600;
    word-wrap: break-word;
    line-height: 1.4;
}

.task-badges-section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

.badges-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

.task-badge {
    font-size: 0.875rem;
    padding: 0.35rem 0.65rem;
    white-space: nowrap;
}

.overdue-text {
    font-size: 0.875rem;
    white-space: nowrap;
}

.project-link-btn {
    white-space: nowrap;
    min-height: 32px;
}

.task-info-list {
    padding: 0;
}

.task-info-item {
    padding: 0.5rem 0;
    font-size: 0.95rem;
    line-height: 1.6;
    border-bottom: 1px solid #f0f0f0;
}

.task-info-item:last-child {
    border-bottom: none;
}

.task-info-item strong {
    display: inline-block;
    min-width: 120px;
    margin-left: 0.5rem;
}

.employee-section {
    margin-top: 1rem;
}

.section-label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
    color: #495057;
}

.employee-card {
    border: 1px solid #e9ecef;
    border-radius: 0.375rem;
}

.employee-info {
    gap: 0.75rem;
}

.employee-avatar-wrapper {
    flex-shrink: 0;
}

.employee-avatar {
    width: 40px;
    height: 40px;
}

.employee-details {
    flex: 1;
    min-width: 0;
}

.employee-name {
    font-size: 0.95rem;
    word-wrap: break-word;
    line-height: 1.5;
}

.employee-nickname {
    font-size: 0.9rem;
    color: #6c757d;
}

.description-section,
.notes-section {
    margin-top: 1rem;
}

.description-text,
.notes-text {
    font-size: 0.95rem;
    line-height: 1.6;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: #495057;
    margin-top: 0.5rem;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
    .task-details-card {
        padding: 0.75rem;
        margin-bottom: 1rem;
    }

    .task-title {
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    .task-badges-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }

    .badges-row {
        width: 100%;
        gap: 0.5rem;
    }

    .task-badge {
        font-size: 0.8rem;
        padding: 0.3rem 0.6rem;
    }

    .overdue-text {
        font-size: 0.8rem;
    }

    .project-link-btn {
        width: 100%;
        justify-content: center;
        min-height: 40px;
        font-size: 0.9rem;
    }

    .task-info-list {
        margin-bottom: 1rem;
    }

    .task-info-item {
        padding: 0.75rem 0;
        font-size: 0.9rem;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }

    .task-info-item strong {
        min-width: auto;
        margin-left: 0;
        margin-bottom: 0.25rem;
        font-size: 0.85rem;
        color: #6c757d;
    }

    .employee-section {
        margin-top: 1rem;
    }

    .section-label {
        font-size: 0.9rem;
        margin-bottom: 0.75rem;
    }

    .employee-card {
        padding: 0.75rem !important;
    }

    .employee-card .card-body {
        padding: 0.5rem !important;
    }

    .employee-info {
        gap: 0.5rem;
    }

    .employee-avatar {
        width: 36px !important;
        height: 36px !important;
        font-size: 0.875rem !important;
    }

    .employee-name {
        font-size: 0.9rem;
    }

    .employee-nickname {
        font-size: 0.85rem;
        display: block;
        margin-top: 0.25rem;
    }

    .description-section,
    .notes-section {
        margin-top: 1rem;
    }

    .description-text,
    .notes-text {
        font-size: 0.9rem;
        padding: 0.5rem;
        background-color: #f8f9fa;
        border-radius: 0.25rem;
    }
}

@media (max-width: 576px) {
    .task-details-card {
        padding: 0.5rem;
        margin-bottom: 0.75rem;
    }

    .task-title {
        font-size: 1.1rem;
        margin-bottom: 0.75rem;
    }

    .task-badge {
        font-size: 0.75rem;
        padding: 0.25rem 0.5rem;
    }

    .overdue-text {
        font-size: 0.75rem;
    }

    .project-link-btn {
        min-height: 44px;
        font-size: 0.875rem;
        padding: 0.5rem 1rem;
    }

    .task-info-item {
        padding: 0.5rem 0;
        font-size: 0.85rem;
    }

    .task-info-item strong {
        font-size: 0.8rem;
    }

    .section-label {
        font-size: 0.85rem;
    }

    .employee-card {
        padding: 0.5rem !important;
    }

    .employee-card .card-body {
        padding: 0.5rem !important;
    }

    .employee-avatar {
        width: 32px !important;
        height: 32px !important;
        font-size: 0.75rem !important;
    }

    .employee-name {
        font-size: 0.85rem;
    }

    .description-text,
    .notes-text {
        font-size: 0.85rem;
        padding: 0.5rem;
    }
}

/* Touch-friendly improvements */
@media (hover: none) and (pointer: coarse) {
    .project-link-btn {
        min-height: 44px; /* iOS recommended touch target size */
    }

    .task-badge {
        min-height: 32px;
        display: inline-flex;
        align-items: center;
    }
}
</style>
